import React from "react";




export default  function Error404(props) {
    return <h1 className='text-center'>Upsss...<br/> Error 404</h1>;
}